import React from "react";
import styles from "./CheckInput.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  baseColor: "black" | "white";
  id: string;
  name: string;
  handler: (value: string) => void;
  label: string;
  initial_value: boolean;
};

const CheckInput: React.FC<Props> = ({
  baseColor,
  id,
  name,
  handler,
  label,
  initial_value,
}) => {
  return (
    <span className={styles["checkInput"]}>
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={initial_value}
        className={styles["checkInput__input"]}
        onChange={() => handler(id)}
      />
      <label
        htmlFor={id}
        className={`${styles["checkInput__label"]} ${styles[baseColor]}`}
      >
        <span>
          <FontAwesomeIcon icon={["fas", "check"]} />
        </span>
        <span>{label}</span>
      </label>
    </span>
  );
};

export default CheckInput;
